<template>
  <div class="boxMenu">
    <div class="boxMenuRow">
      <v-card class="boxMenuItem" @click="openNahaLibraryPage('https://www.city.naha.okinawa.jp/lib/index.html#sp_header_logo')">
        <img src="@/assets/hp.png" alt="" />
        <v-card-text class="ma-0 pa-0" style="text-align: center; font-size:1rem">那覇市立図書館</v-card-text>
      </v-card>
      <v-card class="boxMenuItem" @click="openNewWindow">
        <img src="@/assets/search.png" alt="" />
        <v-card-text class="ma-0 pa-0" style="text-align: center; font-size:1rem">利用状況参照</v-card-text>
      </v-card>
    </div>
    <div class="boxMenuRow">
      <v-card class="boxMenuItem"
        @click="openNahaLibraryPage('https://www.city.naha.okinawa.jp/lib/allNewsList.html#sp_header_logo')">
        <img src="@/assets/news.png" alt="" />
        <v-card-text class="ma-0 pa-0" style="text-align: center; font-size:1rem">新着情報</v-card-text>
      </v-card>

      <v-card class="boxMenuItem" @click="openNahaLibraryPage('https://ilisod011.apsel.jp/naha-library/calendars')">
        <img src="@/assets/calendar.png" alt="" />
        <v-card-text class="ma-0 pa-0" style="text-align: center; font-size:1rem">閉館カレンダー</v-card-text>
      </v-card>
    </div>
  </div>
</template>
  
<script>
import { mapState } from "vuex";
import liff from "@line/liff";
const FRONT_DOMAIN = process.env.VUE_APP_FRONT_DOMAIN
export default {
  name: "HomeMenus",
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      lineId: (state) => state.lineId,
    }),
  },
  methods: {
    openNahaLibraryPage(url) {
      liff.openWindow({
        url: url
      });
    },
    openNewWindow() {
      // LIFF内ウィンドウで自分自身を開く
      liff.openWindow({
        url: FRONT_DOMAIN + "/openNewWindow?line_uid=" + this.lineId
      });
    },
  }
};
</script>
<style>
.boxMenu {
  padding: 0vh 1.5vh;
}
.boxMenuRow {
  display: flex;
  justify-content: space-between;
}
.boxMenuRow:first-child {
  margin-bottom: min(1.6vh, 16px);
}
.boxMenuRow .boxMenuItem {
  height: 18vh;
  max-height: 153px;
  border-radius: 10px;
  color: #000;
  background: #fcedef;
  /* border: solid 1px rgba(0, 0, 0, 0.2); */
  padding: 16px 16px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48.2%;
}
.boxMenuRow .boxMenuItem img {
  height: 100%;
}
.boxMenuRow .boxMenuItem:first-child {
  margin-right: 2%;
}
.boxMenuRow .boxMenuItem h3 {
  font-size: 1.1rem;
  margin: 1px 0 0;
}
</style>